module.exports = __webpack_public_path__ + "static/media/stat-icon.868870cf.svg";